'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcWritePencilFill(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcWritePencilFill');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.8701H22.29V20.8701H10L12 18.8701Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.8301V20.8701H8.08L18.08 10.8301L13.02 5.81006L3 15.8301Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.65 8.29976C21.2 7.65976 21.5 6.83976 21.5 5.99976C21.5 4.03976 19.89 2.39976 17.91 2.39976C17.06 2.39976 16.24 2.72976 15.56 3.29976L13.96 4.84979L19.02 9.86979L20.62 8.31976L20.65 8.28976V8.29976Z",
    fill: fill || '#1E1E23'
  }));
}
var IcWritePencilFill$1 = /*#__PURE__*/memo(IcWritePencilFill);

export { IcWritePencilFill$1 as default };
